/**
 * The AI reports "no value found" either with the explicit `NOT_FOUND` sentinel
 * or an empty / whitespace-only string. Both mean the same thing and must be
 * treated identically wherever a cell's not-found state is decided — otherwise
 * an empty not-found value falls through to the mapping-error branch and
 * surfaces the yellow triangle instead of the "No Data Found" state (CD-1504).
 *
 * Lives in this dependency-free module (no MUI / component imports) so consumers
 * that only need the predicate — e.g. `useAiCellStateMap` — can import it
 * without pulling in the heavyweight cell renderers.
 */
export const aiReportedNoValue = (value: string): boolean =>
  value.trim() === "" || value === "NOT_FOUND";
